import React from 'react'
import ProjectList from '../../components/projects/projectlist'

function index() {
  return (
    <>
        <ProjectList />
    </>
  )
}

export default index